import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withRouterConfig, RouteReuseStrategy  } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { Theme } from './theme';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { MessageService } from 'primeng/api';
import { AuthInterceptor } from './core/interceptors/auth.interceptors';
import { AutenticacaoInterceptor } from './core/interceptors/autenticacao.interceptors';
import { LoadingInterceptor } from './core/interceptors/loading.interceptors';
import { OAuthModule } from 'angular-oauth2-oidc';
import { ptBr } from '../assets/locale/locale-ptBr'
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';
import { NoReuseStrategy } from './no-reuse.strategy';

export const appConfig: ApplicationConfig = {
  providers: [

    provideHttpClient(withInterceptors([
      LoadingInterceptor,
      AuthInterceptor,
      AutenticacaoInterceptor
    ])),

    importProvidersFrom(
      OAuthModule.forRoot({
        resourceServer: {
          sendAccessToken: true
        }
      })
    ),

    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withRouterConfig({ onSameUrlNavigation: 'reload'})),
    { provide: RouteReuseStrategy, useClass: NoReuseStrategy },
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Theme,
        options: {
          darkModeSelector: '.my-app-dark'
        },
      },
      translation: ptBr
    }),
    MessageService,
    importProvidersFrom(DynamicDialogModule),
    DialogService,
  ]
};
